export const PRODUCT_LOG_ERROR = 'PRODUCT_LOG_ERROR';
export const PRODUCT_ASYNC_START = 'PRODUCT_ASYNC_START';
export const PRODUCT_ASYNC_END = 'PRODUCT_ASYNC_END';
export const CREATE_PRODUCT_PAYOUT = 'CREATE_PRODUCT_PAYOUT';
export const CREATE_PRODUCT_COLLECTION = 'CREATE_PRODUCT_COLLECTION';
export const EDIT_PRODUCT_COLLECTION = 'EDIT_PRODUCT_COLLECTION';
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';
export const FETCH_PRODUCT_DETAILS = 'FETCH_PRODUCT_DETAILS';
export const RESET_PRODUCT_DETAILS = 'RESET_PRODUCT_DETAILS';
export const UDPDATE_PRODUCTS_FILTERS = 'UDPDATE_PRODUCTS_FILTERS';
export const UDPDATE_PRODUCTS_PAGINATION = 'UDPDATE_PRODUCTS_PAGINATION';
export const UPDATE_STATUS_ASYNC = 'UPDATE_STATUS_ASYNC';
export const UPDATE_PRODUCT_TYPE = 'UPDATE_PRODUCT_TYPE';
export const RESET_PRODUCT_TRANSACTIONS = 'RESET_PRODUCT_TRANSACTIONS';
export const PRODUCT_FETCH_CLEAR = 'PRODUCT_FETCH_CLEAR';
export const FETCH_PRODUCT_OFFERINGS = 'FETCH_PRODUCT_OFFERINGS';
export const FETCH_PRODUCT_FIELDS = 'FETCH_PRODUCT_FIELDS';
export const FETCH_PRODUCT_KEYS = 'FETCH_PRODUCT_KEYS';
